import { ElementType, ComponentPropsWithoutRef, useMemo } from "react";
import clsx from "clsx";
import { createSpacingClasses, SpacingProps } from "@theme/spacing.ts";

type BreakpointSpace =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | "1"
  | "2"
  | "3"
  | "4"
  | "5"
  | "6"
  | "7"
  | "8"
  | "9"
  | "10"
  | "11"
  | "12";

type PolymorphicProps<E extends ElementType> = {
  as?: E;
  md?: BreakpointSpace;
  sm?: BreakpointSpace;
  xs?: BreakpointSpace;
} & SpacingProps &
  Omit<ComponentPropsWithoutRef<E>, keyof SpacingProps>;

export const GridItem = <E extends ElementType = "div">({
  as,
  className,
  style,
  md,
  sm,
  xs,
  ...rest
}: PolymorphicProps<E>) => {
  const Component = as || "div";

  const mdClass = useMemo(() => `col-grid-md-${md ?? "4"}`, [md]);
  const smClass = useMemo(() => (sm ? `col-grid-sm-${sm ?? "6"}` : ""), [sm]);
  const xsClass = useMemo(() => `col-grid-${xs ?? "10"}`, [xs]);

  const classNames = useMemo(() => {
    const spacingClasses = createSpacingClasses(rest);
    return [xsClass, smClass, mdClass, ...spacingClasses].join(" ");
  }, [mdClass, rest, smClass, xsClass]);

  return (
    <Component
      className={clsx(className, classNames)}
      style={{
        ...style,
      }}
      {...rest}
    />
  );
};
